/// <amd-module name="DistributedTaskUI/SecurityComponent/UserPermissionsAuthorization/Source/RoleAssignmentComponentSecuritySource" />
import Roles_Client = require("SecurityRoles/Client/RestClient/SecurityRoles");
import Roles_Contracts = require("SecurityRoles/Client/Contracts/SecurityRoles");
import { IVssComponentContext } from "VSS/Platform/Layout";
import { IVssRestClientOptions } from "VSS/Platform/Context";

export class RoleAssignmentComponentSecuritySource {

    constructor(
        private context: IVssComponentContext, private serviceInstanceId: string
    ) {
        let restClientOptions: IVssRestClientOptions = {
            serviceInstanceType: serviceInstanceId
        };
        this._rolesClient = this.context.pageContext.getRestClient<Roles_Client.ISecurityRolesRestClient>("dt.vssf.security-roles.client.ISecurityRolesRestClient", restClientOptions);
    }

    public getRoleDefinitions(_scopeId: string): Promise<Roles_Contracts.SecurityRole[]> {
        return (this._rolesClient.getRoleDefinitions(_scopeId));
    }

    public getRoleAssignments(_scopeId: string, _resourceId: string): Promise<Roles_Contracts.RoleAssignment[]> {
        return (this._rolesClient.getRoleAssignments(_scopeId, _resourceId));
    }

    public setRoleAssignments(roleRefs: Roles_Contracts.UserRoleAssignmentRef[], _scopeId: string, _resourceId: string): Promise<Roles_Contracts.RoleAssignment[]> {
        return this._rolesClient.setRoleAssignments(roleRefs, _scopeId, _resourceId);
    }

    public removeRoleAssignments(removedUserIds: string[], _scopeId: string, _resourceId: string): Promise<void> {
        return this._rolesClient.removeRoleAssignments(removedUserIds, _scopeId, _resourceId);
    }

    public beginSave(changedRoleAssignments: Roles_Contracts.UserRoleAssignmentRef[], _scopeId: string, _resourceId: string): Promise<Roles_Contracts.RoleAssignment[]> {
        return this._rolesClient.setRoleAssignments(changedRoleAssignments, _scopeId, _resourceId);
    }

    public changeInheritance(_scopeId: string, _resourceId: string, enableInheritance: boolean): Promise<void> {
        return this._rolesClient.changeInheritance(_scopeId, _resourceId, enableInheritance);
    }

    private _rolesClient: Roles_Client.ISecurityRolesRestClient;

}
